export default {"src":"/_next/static/media/0x101d82428437127bf1608f699cd651e6abf9766e.bced648f.svg","height":2000,"width":2000,"blurWidth":0,"blurHeight":0};